import React from 'react'

const Dashboard = () => {
  return (
    <div>
      Dashboard content here..!
    </div>
  )
}

export default Dashboard
